import { isEmpty } from "lodash";
import { useCallback } from "react";
import { KdsStorageKeys, useKdsStorage } from ".";
import { MenuProviderModel } from "../providers/menu-principal-provider/menu-principal-provider-model";

export function useMenuStorage() {
    const { getRegistro, setRegistro, delRegistro } = useKdsStorage();

    const get = useCallback((): MenuProviderModel => {
        let menu = getRegistro(KdsStorageKeys.ConfiguracoesMenu, false) as MenuProviderModel;
        if (isEmpty(menu)) {
            menu = {
                situacao: "Fechado",
                modelo: "Completo"
            };
            setRegistro(KdsStorageKeys.ConfiguracoesMenu, menu, false);
        }
        return menu;
    }, [getRegistro, setRegistro]);

    const persist = useCallback((model: MenuProviderModel) => {
        if (model === undefined) {
            delRegistro(KdsStorageKeys.ConfiguracoesMenu, false);
        } else {
            setRegistro(KdsStorageKeys.ConfiguracoesMenu, model, false);
        }
    }, [delRegistro, setRegistro]);

    return {
        get,
        persist
    };
}
